// Landing especial cando o admin activa "modo beta privado". Substitúe
// o catálogo de marketplace para visitantes anónimos. Os usuarios xa
// autenticados nunca chegan aquí — MarketplacePage só renderiza esta
// landing cando `!user && private_beta_mode === true`.

import { Lock, Mail, ShieldCheck } from 'lucide-react';
import { Link } from 'react-router-dom';

export default function PrivateBetaLanding(): JSX.Element {
  return (
    <main className="min-h-[80vh] flex items-center justify-center bg-subtle px-6 py-16">
      <section className="max-w-2xl w-full bg-white rounded-3xl shadow-card-hover border border-border p-10 sm:p-14 text-center">
        <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-rauxa/10 mb-6">
          <Lock size={28} className="text-rauxa" aria-hidden />
        </div>

        <h1 className="text-3xl sm:text-4xl font-extrabold text-dark mb-3 leading-tight">
          LeyroChain está en modo beta privado
        </h1>
        <p className="text-base text-muted mb-8 leading-relaxed">
          Estamos a afinar a plataforma cun grupo cerrado de gandeiros, veterinarios e compradores
          piloto. O rexistro público estará dispoñible en breve.
        </p>

        <div className="grid sm:grid-cols-2 gap-4 mb-8 text-left">
          <div className="rounded-xl border border-border p-4 bg-subtle/40">
            <div className="flex items-center gap-2 mb-2">
              <ShieldCheck size={18} className="text-rauxa" aria-hidden />
              <h3 className="text-sm font-semibold text-dark">Xa tes conta?</h3>
            </div>
            <p className="text-xs text-muted mb-3 leading-relaxed">
              Inicia sesión con normalidade. O catálogo segue dispoñible para usuarios autenticados.
            </p>
            <Link
              to="/marketplace/login"
              className="inline-block text-sm font-semibold text-rauxa hover:underline"
            >
              Iniciar sesión →
            </Link>
          </div>

          <div className="rounded-xl border border-border p-4 bg-subtle/40">
            <div className="flex items-center gap-2 mb-2">
              <Mail size={18} className="text-rauxa" aria-hidden />
              <h3 className="text-sm font-semibold text-dark">Queres acceso anticipado?</h3>
            </div>
            <p className="text-xs text-muted mb-3 leading-relaxed">
              Escríbenos co teu nome, explotación e rol — abrimos contas piloto puntualmente.
            </p>
            <a
              href="mailto:hola@leyro.es?subject=Acceso%20beta%20LeyroChain"
              className="inline-block text-sm font-semibold text-rauxa hover:underline"
            >
              hola@leyro.es →
            </a>
          </div>
        </div>

        <p className="text-xs text-muted">
          A trazabilidade dixital do gando galego, paso a paso. Grazas pola paciencia.
        </p>
      </section>
    </main>
  );
}
